import styled from "@emotion/styled";
import { fonts } from "styles/fonts";
import { colors } from "styles/colors";
import { ButtonWrap } from "shared/Button/styled";
import { BtnToolBarWrap } from "shared/BtnToolBar/styled";
import { ModalContent } from "shared/Modal/styled";
import { BtnsGroupWrap, ItemBtnGroup } from "shared/BtnsGroup/styled";
import { HeadBlockType1 } from "styles/AddRecipe.styled";

export const MainTitle = styled.div`
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 80%;
  &:first-letter {
    text-transform: uppercase;
  }
  @media (min-width: 769px) {
    line-height: 1;
  }
`;

export const RecipeTitle = styled.h1`
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  line-height: 1.2;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 80%;
  margin-bottom: 0;
  &:first-letter {
    text-transform: uppercase;
  }
  @media (min-width: 769px) {
    line-height: 1;
  }
`;

export const MainTitleContainer = styled.div`
  flex: 1 1 80%;
`;

export const Title = styled.div`
  margin-bottom: 18px;
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  @media (min-width: 769px) {
    margin-bottom: 28px;
  }
`;
export const TitleDirection = styled.h2`
  margin-bottom: 18px;
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
  @media (min-width: 769px) {
    margin-bottom: 28px;
  }
`;
export const TitleIngredients = styled.h2`
  margin: 0px;
  font-family: ${fonts.rubikMedium};
  font-size: 24px;
  @media (min-width: 769px) {
    margin-bottom: 0px;
  }
`;
export const HeadBlock = styled.div`
  margin-top: 54px;
  margin-bottom: 31px;
  margin-top: 29px;
  margin-bottom: 19px;

  &.add-recipe-preview {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media (min-width: 769px) {
    margin-top: 0;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
    ${BtnToolBarWrap} {
      margin-left: 35px;
    }
  }

  ${MainTitle} {
    margin-bottom: 0;
  }
`;

export const ToolBarWrap = styled.div`
  display: flex;
`;

export const IngredientsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 24px;
`;

export const IngredientRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  margin-top: 16px;
`;

export const IngredientName = styled.div`
  color: #111;
  font-family: ${fonts.rubikRegular};
  font-size: 16px;
`;

export const IngredientNote = styled.div`
  font-family: ${fonts.rubikRegular};
  font-size: 12px;
  font-style: italic;
  color: #adadad;
`;

export const IngredientQuantity = styled.div`
  color: #111;
  font-family: ${fonts.rubikMedium};
  font-size: 16px;
`;

export const GroupItem = styled.div`
  ${(props) =>
    props.area_notes &&
    `
    grid-column-start: 1;
    grid-column-end: 4;
    border-bottom: 1px solid ${colors.GREY_LIGHT};
    
    `};
  ${(props) =>
    props.column &&
    `
    display: flex;
    flex-direction: column;
    `};
`;
export const SupItem = styled.sup`
  ${(props) => props.left && `padding-left: 8px`};
  ${(props) => props.right && `padding-right: 8px`};
`;

export const BlankBlock = styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
`;

export const GroupItemNotes = styled.div`
  color: ${colors.GREY};
  font-family: ${fonts.latoRegular};
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  grid-column-start: 3;
  grid-column-end: 3;
  border-bottom: 1px solid ${colors.GREY_LIGHT};
  padding-bottom: 13px;
`;
export const GroupTitle = styled.div`
  font-size: 19px;
  padding: 0 0 1px;
  line-height: 1;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
  font-family: ${fonts.rubikRegular};
  margin-bottom: 22px;
  @media (min-width: 769px) {
    padding: 0 0 1px;
  }
  margin-top: 32px;
`;
export const GroupItems = styled.div`
  ${(props) => props.border && `border-top: 1px solid ${colors.GREY_LIGHT}`};
  font-size: 14px;
  line-height: 17px;
  word-break: break-word;

  display: grid;
  grid-template-columns: minmax(60px, max-content) minmax(80px, max-content) 1fr;

  ${GroupItem} {
    display: flex;
    padding: 14px 0 5px;
    font-family: ${fonts.latoBold};
    color: ${colors.GREY_DARK};
    padding-right: 10px;
  }
`;

export const IngredientsWrap = styled.div``;
export const IngredContainer = styled.div`
  ${GroupTitle} {
    margin-bottom: 0;
  }
  + ${ButtonWrap} {
    margin-top: 21px;
    .icon {
      fill: ${colors.RED};
    }
    @media (min-width: 769px) {
      margin-top: 30px;
    }
  }
`;
export const DirectionsWrap = styled.div`
  margin-top: 21px;
  word-break: break-word;
  line-height: 1.35;
  color: ${colors.GREY_SEMIDARK};
  &:first-of-type {
    margin-top: 0;
  }
  ${Title} {
    margin-bottom: 17px;
    font-size: 14px;
    font-family: ${fonts.latoBold};
    border-bottom: 1px solid ${colors.GREY_LIGHT};
    color: ${colors.GREY_DARK};
  }
  ${GroupTitle} {
    margin-bottom: 5px;
    font-size: 14px;
    color: ${colors.GREY_DARK};
    font-family: ${fonts.latoBold};
    border: none;
  }
`;
export const RecipeColumn = styled.div`
  @media (min-width: 1024px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  ${IngredientsWrap} + ${IngredientsWrap} {
    margin-top: 34px;
  }
`;

export const RecipeRow = styled.div`
  margin-top: 8px;
  background-color: ${colors.WHITE};
  margin-bottom: 50px;
  position: relative;

  ${RecipeColumn} + ${RecipeColumn} {
    margin-top: 30px;
  }
  @media (min-width: 1024px) {
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 73px;
    ${RecipeColumn} + ${RecipeColumn} {
      margin-top: 0;
    }
  }
`;

/* Recipe Preview */
export const CategoryRecipe = styled.div``;
export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: -13px;
  margin-right: -13px;
  > * {
    padding-left: 13px;
    padding-right: 13px;
  }
  ${ButtonWrap} {
    margin-top: 15px;
    font-family: ${fonts.robotoNormal};
  }
  @media (min-width: 769px) {
    flex-direction: row;
    flex-wrap: wrap;
    ${ButtonWrap} {
      margin-top: 20px;
      background-color: ${colors.RED};
      border-color: ${colors.property};
      color: ${colors.WHITE};
      .icon {
        stroke: ${colors.WHITE};
      }
    }
  }
  ${ButtonWrap} {
    padding: 8px 20px;
    font-size: 18px;
    .icon {
      margin-right: 6px;
    }
  }
`;
export const PreviewButtons = styled.div`
  margin-top: auto;

  ${ButtonWrap} {
    width: 100%;
    &#free,
    &#bought,
    &#buy {
      padding: 9px 27px;
      letter-spacing: 1px;

      @media (min-width: 769px) {
        width: auto !important;
        &#free,
        &#bought,
        &#buy {
          margin-top: 26px;
          padding: 8px 22px;
          letter-spacing: normal;
        }
        &#free {
          background-color: ${colors.GREY_LIGHT} !important;
          border-color: ${colors.GREY_LIGHT} !important;
          color: ${colors.GREY_SEMIDARK} !important;
        }
      }
    }
  }

  ${ButtonGroup} {
    @media (min-width: 769px) {
      ${ButtonWrap} {
        font-family: ${fonts.robotoNormal};
        background-color: ${colors.RED};
        border-color: ${colors.property};
        color: ${colors.WHITE};
        .icon {
          stroke: ${colors.WHITE};
        }
      }
    }
  }

  ${ButtonGroup} {
    ${ButtonWrap} {
      padding: 8px 20px;
    }
  }
`;

export const PreviewRecipe = styled.div`
  margin-bottom: 16px;
  @media (min-width: 1024px) {
    border-bottom: 1px solid ${colors.GREY_LIGHT};
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
    > * {
      margin-top: 22px;
    }
  }
`;
export const PreviewRecipeType1 = styled(PreviewRecipe)`
  @media (min-width: 1024px) {
    padding-bottom: 30px;
  }
`;
export const PreviewImg = styled.div`
  position: relative;
  height: 328px;
  margin-bottom: 20px;
  width: 100%;
  overflow: hidden;
  border-radius: 20px;
  overflow: hidden;
  background-color: ${colors.GREY_LIGHT};
  img {
    border-radius: 10px;
    display: block;
    height: 100%;
    width: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center center;
  }
  @media (min-width: 1024px) {
    height: 400px;
    flex: 0 0 400px;
    max-width: 400px;
    margin-bottom: 0;
    margin-right: 30px;
    border-radius: 20px;
    margin-top: 10px !important;
  }
`;
export const NoImage = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: block;
  height: 100%;
  width: 100%;
  max-width: none;
  object-fit: cover;
  object-position: center center;
  background-color: ${colors.GREY_LIGHT};
  color: #222424;
  font-family: ${fonts.latoBold};
  font-size: 24px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    height: 127px;
    width: 127px;
    display: block;
    background: url("/images/noimage.png") no-repeat 0 0;
    background-size: cover;
  }
`;
export const PreviewTime = styled.div``;
export const PreviewYield = styled.div``;
export const PreviewDesc = styled.div``;
export const PreviewInfo = styled.div`
  letter-spacing: -0.065px;
  > * {
    margin-bottom: 17px;
  }
  > ${ToolBarWrap} {
    margin-bottom: 33px;
  }
  ${PreviewDesc} {
    margin: 17px 0 21px;
    color: ${colors.GREY_SEMIDARK};
    line-height: 1.35;
    letter-spacing: -0.01px;
    @media (min-width: 769px) {
      margin: 13px 0 24px;
    }
    p {
      margin: 0;
    }
    p + p {
      margin-top: 8px;
    }
  }
  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
    > * {
      margin-bottom: 14px;
    }
  }
  @media (min-width: 769px) {
    padding-top: 2px;
    padding-top: 5px;
    > * {
      margin-bottom: 2px;
    }
  }
`;
export const PreviewContent = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
  @media (min-width: 1024px) {
    border-bottom: none;
    margin-top: 22px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
export const PreviewTags = styled.span`
  position: relative;
  margin-right: 4px;
  display: inline-block;
  text-transform: lowercase;
  &:before {
    content: "";
    display: block;
    bottom: 3px;
    left: 0;
    right: 5px;
    position: absolute;
    height: 1px;
    background-color: #222424;
    -webkit-transition: opacity 0.3s ease 0s;
    transition: opacity 0.3s ease 0s;
  }
  &:after {
    content: ",";
    margin-left: 1px;
    font-size: 18px;
    display: inline-block;
    bottom: -1px;
    position: relative;
    color: ${colors.GREY};
  }
  &:last-of-type {
    margin-right: 0;
    &:before {
      right: 0;
    }
    &:after {
      content: "";
    }
  }
`;
export const RecipeRowDisplay = styled(RecipeRow)`
  margin-bottom: 20px;
  @media (min-width: 769px) {
    margin-bottom: 50px;
  }
`;

export const RecipeColumnDirections = styled.div`
  margin-top: 15px;
  @media (min-width: 1024px) {
    margin-top: 0;
    flex: 0 0 59%;
    max-width: 59%;
  }
  ${IngredientsWrap} + ${IngredientsWrap} {
    margin-top: 14px;
  }
  ${DirectionsWrap} {
    margin-top: 22px;
  }
  ${DirectionsWrap} + ${GroupTitle} {
    margin-top: 32px;
  }
`;
export const RecipeColumnIngredients = styled.div`
  ${IngredientsWrap} + ${IngredientsWrap} {
    margin-top: 22px;
  }
  ${ButtonWrap} {
    width: 100%;
    font-size: 16px;
  }
  @media (min-width: 640px) {
    ${ButtonWrap} {
      width: auto;
    }
  }
  @media (min-width: 1024px) {
    flex: 0 0 41%;
    max-width: 41%;
    padding-right: 30px;
    ${IngredientsWrap} + ${IngredientsWrap} {
      margin-top: 32px;
    }
  }
`;

export const PreviewVideo = styled.div`
  position: relative;
  height: 500px;
  background-color: black;
  @media (max-width: 769px) {
    height: 328px;
  }
`;
export const ConversionInProgress = styled.div`
  position: relative;
  height: 500px;
  background-color: silver;
  @media (max-width: 769px) {
    height: 328px;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  flex-direction: column;
`;
export const ModalVideoWrapper = styled.div`
  ${ModalContent} {
    height: 100vh;
  }
`;

export const ModalContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.div`
  margin-top: 20px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.GREY_LIGHT};
  margin-top: 20px;
`;

export const ButtonsInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  margin-top: 20px;
  button {
    width: 40%;
  }
`;

export const IconWrap = styled.div`
  right: 30px;
  cursor: pointer;
  position: absolute;
  margin-top: 5px;
  height: 22px;
  .icon {
    width: 22px;
    line-height: 22px;
    height: 22px;
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 0px 20px 0px;
  margin: 0px 20px 20px 20px;
  border-bottom: 1px solid ${colors.GREY_SEMILIGHT};
  .icon {
    cursor: pointer;
    width: 22px;
    line-height: 22px;
    height: 22px;
  }
`;

export const MainImage = styled.img``;

export const InfoHeading = styled.div`
  font-family: ${fonts.abhayaBold};
  font-size: 24px;
`;
export const Item = styled.div``;
export const InfoBlock = styled.div`
  padding: 25px 16px 26px 16px;
  margin: 0 -16px 29px;
  background-color: ${colors.GREY_LIGHT};
  margin-top: ${(props) => (props.type === "primary" ? `36px` : `0`)};
  @media (min-width: 769px) {
    margin: 20px 0 33px;
    padding: 21px 16px;
    border-radius: 10px;
  }
  ${HeadBlockType1} {
    margin: 0 auto;
    padding-bottom: 0;
    border: none;
    max-width: 984px;
    width: 100%;
    > div + div {
      padding-top: 0;
    }
  }
  ${BtnsGroupWrap} {
    @media (max-width: 768px) {
      margin-left: -4px;
      margin-right: -4px;
    }
    ${ItemBtnGroup} {
      margin-top: 6px;

      @media (max-width: 768px) {
        margin-left: 0;
        padding-left: 4px;
        padding-right: 4px;
      }
      @media (min-width: 769px) {
        margin-top: 5px;
      }
    }
    ${ButtonWrap} {
      padding: 5px 8px 4px;
      min-width: 88px;
      @media (min-width: 769px) {
        min-width: 70px;
        padding: 6px 5px;
      }
    }
  }
`;

export const ServingsWrapperPreview = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  margin-bottom: 20px;
  border-top: 1px solid ${colors.GREY_SEMILIGHT};

  @media (min-width: 769px) {
    padding-top: 0px;
    margin-top: -5px;
    margin-bottom: 5px;
    border-top: none;
  }
`;
